<template>
  <div>
    <div data-cy="LoadingSpinnerDiv" class="Loading__Div">
      <img :src="`${publicPath}${logo}`" class="LetiLogo" alt="Логотип ЛЭТИ" />
      <b class="LoadingText text-primary">{{ textSpinner }}</b>
    </div>
  </div>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator'
import LogoPicker from '@/utils/logoChanger'
import { loadingMapper } from '@/store/modules/loading'

const Mappers = Vue.extend({
  computed: {
    ...loadingMapper.mapGetters(['textSpinner']),
  },
})

@Component
export default class Loading extends Mappers {
  private publicPath = process.env.BASE_URL
  private logo = LogoPicker.getActualLogo()
}
</script>

<style lang="scss" scoped>
@import '@/scss/_colors.scss';

.Loading__Div {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 80vh;

  .LetiLogo {
    width: 300px;
    height: 300px;
    animation: rotation 8s infinite linear;

    @keyframes rotation {
      from {
        transform: rotate(0deg);
      }
      to {
        transform: rotate(359deg);
      }
    }
  }

  .LoadingText {
    margin-top: 16px;
    font-size: 20px;
    color: $etu-official-color-blue;
  }
}
</style>
